import { Attrs, MinzeElement } from 'minze'

export interface LvcPersonIcon {
  dataWidth: number
  dataHeight: number
}

export class LvcPersonIcon extends MinzeElement {
  attrs: Attrs = [
    ['data-width', 33],
    ['data-height', 32],
  ]
  html = () => `
  <svg width="${this.dataWidth}" height="${this.dataHeight}" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.69298 28C7.8633 27.9429 10.2894 27.7314 13.4323 27.7314C14.9555 27.7314 19.4153 27.8225 21.7766 27.8217C23.3705 27.8211 24.8019 27.7789 26.0254 27.7578C26.9159 27.7424 27.6471 27.0209 27.5482 26.1359C27.2083 23.0953 25.8735 18.6677 22.2825 17.1794C16.9028 14.9498 11.2847 16.2948 8.53074 19.6892C6.32759 22.4048 4.74886 26.2441 4.5 27.7314M16.2742 4.14477C19.102 3.96953 21.3071 6.31201 21.3071 8.98425C21.3071 11.6565 19.2597 13.2852 16.6883 13.2852C14.1169 13.2852 11.9027 11.4678 11.9027 8.79553C11.9027 6.4017 13.6164 4.38823 15.8135 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  
  `

  css = () => `
    
  `
}
